import { Injectable, Input } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ALERTS, Constants } from '../common';
import { IMenuOption } from '../models';
import { AlertsService } from '../services/alerts.service';
import { AuthenticationService } from '../services/authentication.service';
import { SideBarService } from '../services/side-bar.service';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard implements CanActivate {
  
  opened: boolean;
  menu: IMenuOption[];
  @Input() currentUser: any;

  constructor(
    private alertService: AlertsService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private sidebarService: SideBarService,
    private storageService : StorageService
  ) {
    this.menu = Constants.GetMenu;
    this.authenticationService.currentUser.subscribe(next => this.currentUser = next);
    this.sidebarService.toggler.subscribe((toggle) => (this.opened = toggle));
  }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.currentUser || this.router.navigate(['/login']);

    const TARGET = route.url[0].path;
    const MENU_OPTION = this.FindPath(TARGET);

    if (!(new Date(this.currentUser['ExpireTime']) > new Date())) {
      this.sidebarService.currentPath.next('Inicio');
      this.authenticationService.logout();
      this.alertService.ShowSmallCornerAlert('Lo sentimos, la sesión ha expirado', 3);
      this.sidebarService.toggler.next(false);
    }

    if (!MENU_OPTION) {
      this.alertService.ShowSmallCornerAlert(`No tiene acceso a esta página`, ALERTS.warning);
      this.sidebarService.currentPath.next('Inicio');
      this.router.navigateByUrl('home');
      return false;
    }

    this.sidebarService.currentPath.next(MENU_OPTION.Name);

    if (MENU_OPTION.RequiredPerm === 'V_Home') return true;
    const PERMISSION = this.storageService.GetPermissions().find(x => x.Code === MENU_OPTION.RequiredPerm);

    if (!PERMISSION) {
      this.alertService.ShowSmallCornerAlert(`No tiene acceso a esta página`, ALERTS.warning);
      this.sidebarService.currentPath.next('Inicio');
      this.router.navigateByUrl('home');
      return false;
    }
    
    return true;
  }

  FindPath(_path: string): IMenuOption {
    _path = '/' + _path;
    for (let c = 0; c < this.menu.length; c++) {
      if (this.menu[c].Route == _path) {
        return this.menu[c];

      }
      for (let d = 0; d < this.menu[c].Children.length; d++) {
        if (this.menu[c].Children[d].Route == _path) {
          return this.menu[c].Children[d];
        }
        for (let e = 0; e < this.menu[c].Children[d].Children.length; e++) {
          if (this.menu[c].Children[d].Children[e].Route == _path) {
            return this.menu[c].Children[d].Children[e];
          }
        }
      }
    }
  }

}
